<template>
  <div :key="key" class="product-prices">
    <template v-if="prices">
      <template v-if="pricePerItem">
        <template v-if="checkDiscount">
          <p class="title is-marginless">
            <s>{{ toCurrency(prices.basePrice, null, prices.currency) }}</s>
            <span class="price-discount">
              {{ toCurrency(prices.price, null, prices.currency) }}
              <span v-if="typePrices" class="price-info">
                {{ typePrices === 'brutto' ? $t('fields.withVat') : $t('fields.withoutVat') }}
              </span>
            </span>
          </p>
        </template>
        <template v-else>
          <p class="title is-marginless">
            {{ toCurrency(prices.price, null, prices.currency) }}
            <span v-if="typePrices" class="price-info">
              {{ typePrices === 'brutto' ? $t('fields.withVat') : $t('fields.withoutVat') }}
            </span>
          </p>
        </template>
      </template>
      <template v-else>
        <template v-if="checkDiscountTotal">
          <p class="title is-marginless">
            <s>{{ toCurrency(prices.totalBasePrice, null, prices.currency) }}</s>
            <span class="price-discount">
              {{ toCurrency(prices.totalPrice, null, prices.currency) }}
              <span v-if="typePrices" class="price-info">
                {{ typePrices === 'brutto' ? $t('fields.withVat') : $t('fields.withoutVat') }}
              </span>
            </span>
          </p>
        </template>
        <template v-else>
          <p class="title is-marginless">
            {{ toCurrency(prices.totalPrice, null, prices.currency) }}
            <span v-if="typePrices" class="price-info">
              {{ typePrices === 'brutto' ? $t('fields.withVat') : $t('fields.withoutVat') }}
            </span>
          </p>
        </template>

        <p v-if="showPricePerItem" class="price-per-item">
          <span v-if="checkDiscount" class="has-text-weight-bold"><s>{{ toCurrency(prices.basePrice, null, prices.currency) }}</s></span>
          {{ $t('products.pricePerItem', {price: toCurrency(prices.price, null, prices.currency)}) }}
          <span v-if="typePrices">
            {{ typePrices === 'brutto' ? $t('fields.withVat') : $t('fields.withoutVat') }}
          </span>
        </p>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    prices: {
      type: Object,
      default () {
        return {}
      }
    },
    typePrices: {
      type: String,
      default: null
    },
    pricePerItem: {
      type: Boolean
    }
  },
  data () {
    return {
      key: 0
    }
  },
  computed: {
    checkDiscount () {
      return this.prices.price !== this.prices.basePrice
    },
    checkDiscountTotal () {
      return this.prices.totalPrice !== this.prices.totalBasePrice
    },
    showPricePerItem () {
      return this.prices.price !== this.prices.totalPrice
    }
  },
  watch: {
    prices () {
      this.key++
    }
  }
}
</script>
